"use client";

import { CheckCircle2, XCircle } from "lucide-react";
import { useEffect, useState } from "react";

type ToastPayload = { title: string; description?: string; type?: "success" | "error" };

export function toast(payload: ToastPayload) {
  window.dispatchEvent(new CustomEvent<ToastPayload>("app-toast", { detail: payload }));
}

export function Toaster() {
  const [message, setMessage] = useState<ToastPayload | null>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      setMessage((event as CustomEvent<ToastPayload>).detail);
      window.setTimeout(() => setMessage(null), 3200);
    };
    window.addEventListener("app-toast", handler);
    return () => window.removeEventListener("app-toast", handler);
  }, []);

  if (!message) return null;

  const isError = message.type === "error";
  const Icon = isError ? XCircle : CheckCircle2;

  return (
    <div className="fixed right-4 top-4 z-[80] max-w-sm rounded-2xl border border-ink/10 bg-white p-4 shadow-soft">
      <div className="flex gap-3">
        <Icon className={isError ? "h-5 w-5 shrink-0 text-red-600" : "h-5 w-5 shrink-0 text-emerald-600"} />
        <div>
          <p className="font-bold text-ink">{message.title}</p>
          {message.description ? <p className="mt-1 text-sm text-muted">{message.description}</p> : null}
        </div>
      </div>
    </div>
  );
}
